<template>
	<!-- 问题解答 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">问题解答</p>
				</div>
			</div>
		</van-sticky>
		<div class="wtjdBoxNum">
			<h4>{{title}}</h4>
			<div v-html="content"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				title: '',
				content: ''
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.problem_answer();
		},
		mounted() {},
		methods: {
			back() {
				this.$router.push('/cjwt')
			},
			// jumpUrlwtjd(data){
			// 	this.$router.push({path: '/cjwt'})
			// },
			problem_answer() {
				this.$axios.post(`${this.$api.problem_answer}?problem_id=${this.id}`).then(res => {
					console.log(res)
					this.title = res.data.data.title;
					this.content = res.data.data.content;
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.qjylBox {
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		overflow-x:hidden;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//内容
		.wtjdBoxNum {
			padding: 10px 16px;
			
			h4 {
				font-size: 30px;
				/*px*/
				color: #000000;
				// font-weight: 400;
			}

			div {
				line-height: 40px;
				color: #3d3d3d;
				font-size: 24px;

				/*px*/
				/deep/.MsoNormal {
					/deep/span {
						font-size: 26px !important;
						/*px*/
						color: #3d3d3d !important;
					}
				}

				/deep/img {
					width: 100%!important;
				}
			}
		}
	}
</style>
